export default __webpack_public_path__ + "static/media/0151.704b7782.png";